import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { createXLinearScale, createYScale, defaultDataIdAssessor, getStackedData, stackedBarYScale, xScale } from '@opengov/data-viz';
import { adjustScalesForMinimumBandwidth, assembleAllColors, getCategoriesFromChartData, makeCoordinateSystems, sortCategories, ticksLengthOfShowAsPercentOfTotal } from './chartCalculations';
export var createStackedBarChartCalculations = function createStackedBarChartCalculations(config, showAsPercentOfTotal) {
  var orientation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'vertical';
  var margin = arguments.length > 3 ? arguments[3] : undefined;
  var maxXTickWidth = arguments.length > 4 ? arguments[4] : undefined;
  var customColors = arguments.length > 5 ? arguments[5] : undefined;
  var additionalScaleData = arguments.length > 6 ? arguments[6] : undefined;
  var data = config.data,
      sortOrder = config.sortOrder,
      width = config.width;

  var _makeCoordinateSystem = makeCoordinateSystems(width, margin),
      coordinateSystem = _makeCoordinateSystem.coordinateSystem,
      dimensions = _makeCoordinateSystem.dimensions,
      adjustedMargin = _makeCoordinateSystem.margin; // Pull out categories from data (excluding reserved keys name and id)


  var valueCategories = data && data.length > 0 ? getCategoriesFromChartData(data).toArray() : []; // Generate SVG points from raw data

  var stackedData = getStackedData(data, valueCategories, sortOrder, function (d, key) {
    return d.hasOwnProperty(key) ? d[key] : null;
  });

  var _sortCategories = sortCategories(data, sortOrder),
      sortedCategoriesForColorScale = _sortCategories.sortedCategoriesForColorScale,
      sortedCategories = _sortCategories.sortedCategories;

  var numberOfYTicks = ticksLengthOfShowAsPercentOfTotal(showAsPercentOfTotal);

  var createYScaleWithDimensions = function createYScaleWithDimensions(dim) {
    return showAsPercentOfTotal && orientation === 'vertical' ? createYScale([0, 1], dim.height) : stackedBarYScale(orientation, data, dim, sortedCategories, null, defaultDataIdAssessor, additionalScaleData ? additionalScaleData.toArray() : [], numberOfYTicks);
  };

  var createXScaleWithDimensions = function createXScaleWithDimensions(dim) {
    return showAsPercentOfTotal && orientation === 'horizontal' ? createXLinearScale([0, 1], dim.width) : xScale(orientation, data, dim, sortedCategories, null, defaultDataIdAssessor, additionalScaleData ? additionalScaleData.toArray() : []);
  };

  var adjustedScales = adjustScalesForMinimumBandwidth(orientation, adjustedMargin, dimensions, coordinateSystem, createYScaleWithDimensions, createXScaleWithDimensions);
  var chartColors = assembleAllColors(customColors, sortedCategoriesForColorScale);
  return _objectSpread(_objectSpread({}, adjustedScales), {}, {
    categories: sortedCategories,
    colorMap: chartColors,
    data: data,
    margin: adjustedMargin,
    stackedData: stackedData,
    xTickLabelWidth: maxXTickWidth,
    yTickLabelWidth: 0,
    xTickLabelHeight: 0,
    numberOfYTicks: numberOfYTicks,
    showAsPercentOfTotal: showAsPercentOfTotal
  });
};